import PropTypes from "prop-types";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { FiEdit, FiTrash } from "react-icons/fi";
import Swal from "sweetalert2";
import { api } from "@/api";
import DataTable from "@/components/DataTable/DataTable";
import EditDTModel from "@/components/Modals/EditDTModel";

const DeviceTypeTable = ({ data, getDeviceTypes }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [deviceTypeDataToEdit, setDeviceTypeDataToEdit] = useState();
  const columns = [
    {
      title: "No.",
      render: (row, _, index) => <div>{index + 1}</div>,
      width: "60px",
      align: "center",
    },
    {
      title: "Name",
      render: (row) => row.name,
    },
    {
      title: "Description",
      render: (row) => row?.description,
    },
    {
      title: "Action",
      render: (row) => (
        <div>
          <button className="btn btn-edit me-1" onClick={() => editType(row)} disabled={row.name === "Virtual Device"}>
            <FiEdit />
          </button>
          <button
            className="btn btn-danger"
            onClick={() => confirmDeleteDeviceType(row._id)}
            disabled={row.name === "Virtual Device"}
          >
            <FiTrash />
          </button>
        </div>
      ),
      align: "center",
    },
  ];
  const editType = (data) => {
    setDeviceTypeDataToEdit(data);
    setModalShow(true);
  };

  const confirmDeleteDeviceType = async (typeId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you wish to delete this device type?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        api
          .delete(`/device-type/` + typeId)
          .then(() => {
            getDeviceTypes();

            Swal.fire({
              title: "Done!",
              text: "Device type successfully deleted!",
              icon: "info",
              timer: 2000,
              button: false,
            });
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <div>
      <span className="d-block py-2">Device Type</span>
      <hr className="mt-0" />
      <div className="d-flex justify-content-center">{isLoading && <Spinner animation="border" variant="dark" />}</div>
      <DataTable columns={columns} dataSource={data} />

      {deviceTypeDataToEdit && (
        <EditDTModel
          show={modalShow}
          onHide={() => setModalShow(false)}
          deviceTypeDataToEdit={deviceTypeDataToEdit}
          setModalShow={setModalShow}
          getDeviceTypes={getDeviceTypes}
        />
      )}
    </div>
  );
};

export default DeviceTypeTable;

DeviceTypeTable.propTypes = {
  data: PropTypes.array.isRequired,
  getDeviceTypes: PropTypes.func.isRequired,
};
